export default "__VITE_ASSET__f4416be9__"